import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { EditorBlock, Node, Video } from '../types/models';
import { NodeType } from '../types/enums/attributes';

interface MappedVideo {
  id: string;
  srcUrl: string;
  thumbUrl: string;
}

export const useLoadedVideosStore = defineStore('loaded-videos', () => {
  const videos: Ref<MappedVideo[]> = ref([]);

  const setVideo = (videoId: string, srcUrl: string, thumbUrl: string) => {
    if (!videos.value.some(video => video.id === videoId)) {
      videos.value.push({ id: videoId, srcUrl, thumbUrl });
      return;
    }

    videos.value = videos.value.map(video =>
      video.id === videoId ? { id: videoId, srcUrl, thumbUrl } : video
    );
  };

  const findAllVideoNodesInBlock = (block: EditorBlock) => {
    const videoNodes: Video[] = [];

    block.content.sections.forEach(section =>
      section.rows.forEach(row =>
        row.cells.forEach(cell =>
          cell.nodes.forEach((node: Node) => {
            if (node.type === NodeType.Video && node.videoId) {
              videoNodes.push(node);
            }
          })
        )
      )
    );

    return videoNodes;
  };

  const reset = () => {
    videos.value = [];
  };

  return { setVideo, findAllVideoNodesInBlock, reset, videos };
});
